module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.1@core-js/library/modules/_add-to-unscopables.js
// module id = 79
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/.2.5.1@core-js/library/modules/_add-to-unscopables.js